import React from "react";
import legionLogo from "../../../images/icons/vertical-grey.png";
import gitHubLogo from "../../../images/icons/icons-github.png";
import gitLabLogo from "../../../images/icons//icons-gitlab.png";
import { Link } from "react-router-dom";

const Experience = () => {
  return (
    <>
      <section className="experience-section">
        <h1>Experience</h1>
        <div className="section-content">
          <p>
            I don't have any commercial experience at the moment, as I have just
            completed a training course.
          </p>
          <p>
            However, I am collaborating with the
            <Link
              to={{
                pathname: "//www.legion-marketing.com.ua/",
              }}
              target="_blank"
              className="legion-marketing"
            >
              <img className="legion-logo" src={legionLogo} alt="legion-logo" />
              <span>Legion-marketing agency</span>
            </Link>
            , and I am gradually developing their website.
          </p>
          <p>However, you can see my work as part of the study at:</p>
          <ul className="experience-list">
            <li className="experience-item git-hub">
              <Link
                to={{
                  pathname: "//github.com/ztDiana",
                }}
                target="_blank"
              >
                <img
                  className="experience-item-img"
                  src={gitHubLogo}
                  alt="gitHub-logo"
                />
                https://github.com/ztDiana
              </Link>
            </li>
            <li className="experience-item git-hub">
              <Link
                to={{
                  pathname: "//gitlab.com/dzayats",
                }}
                target="_blank"
              >
                <img
                  className="experience-item-img"
                  src={gitLabLogo}
                  alt="gitLab-logo"
                />
                https://gitlab.com/dzayats
              </Link>
            </li>
          </ul>
          <p>The resume that you view in a web browser is also my work.</p>
        </div>
      </section>
    </>
  );
};
export default Experience;
